var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgManagementProzesse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "model4-icon",
    viewBox: "0 0 268.26 183.23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".model4-icon .cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.26,183.23H0V0H268.26ZM3,180.23H265.26V3H3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.08,
    y: 1.5,
    width: 3,
    height: 180.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 90.11,
    width: 265.26,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.07,
    y: 119.4,
    width: 41.67,
    height: 41.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.07,
    y: 21.7,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.07,
    y: 53.51,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.13,
    y: 21.7,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.13,
    y: 108.98,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.88,
    y: 21.7,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.88,
    y: 108.98,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.88,
    y: 140.24,
    width: 41.67,
    height: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.69,
    y: 148.75,
    width: 100.78,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.61 151.75 15.99 151.75 15.99 30.62 25.61 30.62 25.61 33.62 18.99 33.62 18.99 148.75 25.61 148.75 25.61 151.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.69,
    y: 30.62,
    width: 42.2,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.39 141.74 84.69 141.74 84.69 138.74 91.39 138.74 91.39 65.43 82.7 65.43 82.7 62.43 94.39 62.43 94.39 141.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "253.92 152.15 242.24 152.15 242.24 149.15 250.92 149.15 250.92 33.62 242.24 33.62 242.24 30.62 253.92 30.62 253.92 152.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.23,
    y: 117.9,
    width: 10.19,
    height: 3
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManagementProzesse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/management-prozesse.0d7b5be2.svg";
export { ForwardRef as ReactComponent };